module.exports = __webpack_public_path__ + "5c91f5b536604d68d40100d502bcceb8.png";